import { render, staticRenderFns } from "./shipList.vue?vue&type=template&id=464e18d8&scoped=true&"
import script from "./shipList.vue?vue&type=script&lang=js&"
export * from "./shipList.vue?vue&type=script&lang=js&"
import style0 from "./shipList.vue?vue&type=style&index=0&id=464e18d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464e18d8",
  null
  
)

export default component.exports